import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { AlertCircle } from 'lucide-react';

const ExcelGuideDialog = ({ open, onOpenChange, guide, language }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white border-stone-200 max-w-2xl max-h-[80vh] overflow-y-auto">
      <DialogHeader><DialogTitle>{guide?.title}</DialogTitle></DialogHeader>
      <div className="space-y-4">
        <p className="text-stone-600">{language === 'sv' ? guide?.description_sv : guide?.description_en}</p>
        
        {/* Product columns */}
        <div>
          <h4 className="font-semibold mb-2">{language === 'sv' ? 'Produktkolumner:' : 'Product columns:'}</h4>
          <div className="mb-2">
            <span className="text-sm text-stone-500">{language === 'sv' ? 'Obligatoriska:' : 'Required:'}</span>
            <div className="flex flex-wrap gap-2 mt-1">
              {guide?.product_columns?.required?.map((col) => <span key={col} className="px-2 py-1 bg-red-100 text-red-700 rounded text-sm">{col}</span>)}
            </div>
          </div>
          <div>
            <span className="text-sm text-stone-500">{language === 'sv' ? 'Valfria:' : 'Optional:'}</span>
            <div className="flex flex-wrap gap-2 mt-1">
              {guide?.product_columns?.optional?.map((col) => <span key={col} className="px-2 py-1 bg-stone-100 text-stone-700 rounded text-sm">{col}</span>)}
            </div>
          </div>
        </div>
        
        {/* Variant columns */}
        <div className="bg-[#f5f0f2] p-4 rounded">
          <h4 className="font-semibold mb-2 text-stone-900">{language === 'sv' ? 'Variantkolumner (table_):' : 'Variant columns (table_):'}</h4>
          <p className="text-sm text-[#321a27] mb-2">
            {language === 'sv' ? guide?.variant_columns?.description_sv : guide?.variant_columns?.description_en}
          </p>
          <div className="flex flex-wrap gap-2">
            {guide?.variant_columns?.examples?.map((col) => <span key={col} className="px-2 py-1 bg-stone-100 text-stone-800 rounded text-sm font-mono">{col}</span>)}
          </div>
        </div>
        
        {/* Example */}
        <div>
          <h4 className="font-semibold mb-2">{language === 'sv' ? 'Exempelrad:' : 'Example row:'}</h4>
          <div className="bg-stone-900 text-stone-100 p-3 rounded font-mono text-xs overflow-x-auto">
            {guide?.example_row && Object.entries(guide.example_row).map(([k, v]) => (
              <div key={k}><span className="text-stone-500">{k}:</span> {String(v)}</div>
            ))}
          </div>
        </div>
        
        {/* Notes */}
        <div className="bg-stone-50 p-4">
          <h4 className="font-semibold mb-2 flex items-center gap-2">
            <AlertCircle className="w-4 h-4 text-yellow-500" />
            {language === 'sv' ? 'Viktigt:' : 'Important:'}
          </h4>
          <ul className="text-sm text-stone-600 space-y-1">
            {(language === 'sv' ? guide?.notes_sv : guide?.notes_en)?.map((note, i) => <li key={i}>• {note}</li>)}
          </ul>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);


export default ExcelGuideDialog;
